import { Navigate, Route, Routes } from "react-router";

import { Shell } from "./components/Shell.js";
import { useResource } from "./hooks.js";
import { InvitationPage } from "./pages/InvitationPage.js";
import { KeysPage } from "./pages/KeysPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { MembersPage } from "./pages/MembersPage.js";
import { OrganizationsPage } from "./pages/OrganizationsPage.js";
import { UsersPage } from "./pages/UsersPage.js";
import { type RoutePath } from "./routes.js";
import { type Session } from "./types.js";

const LINKS: { label: string; to: RoutePath }[] = [
  { label: "Organizations", to: "/organizations" },
  { label: "Members", to: "/members" },
  { label: "Keys", to: "/keys" },
  { label: "Users", to: "/users" },
];

export function App() {
  const session = useResource<Session>("/app/control/session");

  if (session.loading) {
    return <p className="p-8 text-sm text-ink/50">Loading</p>;
  }
  if (session.error?.status === 401) return <LoginPage />;
  if (session.error?.status === 403) return <InvitationPage />;
  if (session.error) {
    return <p className="p-8 text-sm text-red-700">{session.error.message}</p>;
  }
  if (!session.value) return <LoginPage />;
  if (!session.value.installOwner) return <InvitationPage />;

  return (
    <Shell
      title="Jaypie Control"
      email={session.value.user.email}
      links={LINKS}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/organizations" replace />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/keys" element={<KeysPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route
          path="/login"
          element={<Navigate to="/organizations" replace />}
        />
      </Routes>
    </Shell>
  );
}
